import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Spinner from 'shopper/components/Spinner';

const Loading = ({ className }) => (
  <div className={twMerge('flex items-center justify-center', className)}>
    <Spinner />
  </div>
);

Loading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Loading;
